module.exports = __webpack_public_path__ + "static/media/05_theheirophant.04e3dbc7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/05_theheirophant.png
// module id = 68
// module chunks = 0